import React, {useEffect, useState} from "react";
import { useLocation } from 'react-router-dom';
import {Col, Row} from "react-bootstrap";
import Header from "../../components/Header/Header";
import {ModalProvider} from "../../context/ModalContext";
import {TariffProvider} from "../../context/TariffContext";
import {ResponseStatusProvider} from "../../context/ResponseStatusContext";
import ModalA from "../../components/Modals/ModalA";
import ModalB from "../../components/Modals/ModalB";
import ModalC from "../../components/Modals/ModalC";
import Tabs from "../../components/Tabs/Tabs";
import TabContentServices from "../../components/Tabs/TabContentServices";
import SectionPage from "../../components/SectionPage/SectionPage";
import CardImage from "../../components/Cards/CardImage";
import CardIcon from "../../components/Cards/CardIcon";
import Counter from "../../components/Counter/Counter";
import SectionOffer from "../../components/Sections/SectionOffer";
import SectionTariff from "../../components/Sections/SectionTariff";
import SectionForm from "../../components/Sections/SectionForm";
import servicesData from '../../data/servicesData.json';
import complexData from '../../data/complexData.json';
import benefitData from '../../data/benefitData.json';
import Footer from "../../components/Footer/Footer";

import {useModal} from "../../context/ModalContext";
import {useResponseStatus} from "../../context/ResponseStatusContext";

const LandingPageContent: React.FC = () => {
    const location = useLocation();
    const {openModalC, openModalA, closeModals} = useModal();
    const {setFormType, setResponseStatus} = useResponseStatus();
    const [modalInitialized, setModalInitialized] = useState(false);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);

        if (!modalInitialized) {
            if (searchParams.has('success')) {
                setFormType('payment');
                setResponseStatus(true);
                openModalC();
                setModalInitialized(true);
            } else if (searchParams.has('failed')) {
                setResponseStatus(false);
                openModalC();
                setModalInitialized(true);
            }
        }
    }, [location.search, modalInitialized]);

    return (
        <>
            <Header/>
            <Counter/>
            <SectionPage title="Комплексный подход к благополучию" idHash="aboutus">
                <Row className="g-4">
                    {complexData.map((complex) => (
                        <Col md={6} key={complex.id}>
                            <CardImage title={complex.title} text={complex.text} image={complex.image}/>
                        </Col>
                    ))}
                </Row>
            </SectionPage>
            <SectionPage>
                <SectionOffer/>
            </SectionPage>
            <SectionPage>
                <SectionTariff/>
            </SectionPage>
            <SectionPage title="Наш сервис — незаменимый помощник" idHash="services">
                {servicesData.length > 1 ? (
                    <Tabs tabs={servicesData}>
                        {servicesData.map((tab, index) => (
                            <TabContentServices
                                key={index}
                                content={tab.content}
                                icons={tab.icons}
                                title={tab.label}
                                onClick={openModalA}
                            />
                        ))}
                    </Tabs>
                ) : (
                    <TabContentServices
                        content={servicesData[0]?.content}
                        icons={servicesData[0]?.icons}
                        title={servicesData[0]?.label}
                        onClick={openModalA}
                    />
                )}
            </SectionPage>
            <SectionPage title="Почему ELS GROUP" className={["darkTheme", "bgTheme"]} idHash="advantages">
                <Row className="g-4">
                    {benefitData.map((benefit) => (
                        <Col md={6} key={benefit.id}>
                            <CardIcon {...benefit} className={["darkTheme"]}/>
                        </Col>
                    ))}
                </Row>
            </SectionPage>
            <SectionPage title="Остались вопросы?" className={["blackTheme"]} idHash="contacts">
                <SectionForm/>
            </SectionPage>
            <Footer/>
            <ModalC/>
            <ModalA/>
            <ModalB/>
        </>
    );
};

const LandingPage: React.FC = () => {
    return (
        <ModalProvider>
            <TariffProvider>
                <ResponseStatusProvider>
                    <LandingPageContent/>
                </ResponseStatusProvider>
            </TariffProvider>
        </ModalProvider>
    );
};

export default LandingPage;
